import { constantRoutes } from '@/router'
import Layout from '@/layout'
import router from '../../router';
import { satisfies } from 'semver';
// 很重要 ===>>>>>
// 路由过滤 ===>>>>>
export function filterAsyncRoutes(routers) {
    return new Promise((resolve,reject) => {
      const res = [];
      for(let i = 0,len = routers.length; i < len;i++){
        if(routers[i].children){
          if(routers[i].component == "Layout"){
              routers[i].component = Layout;
          }
          if(routers[i].path.match(/\//g).length == 2){
              if(!routers[i].component){
                routers[i].component = () => import("@/views" + routers[i].path + "/" + "index.vue");
              };
              let startPage = {
                path: routers[i].path + "/",
                name: routers[i].name + "/",
                component: () => import("@/views" + routers[i].path + "/list.vue"),
                meta: routers[i].meta
              };
              delete routers[i].meta;
              let temp = routers[i].children;
              routers[i].children.unshift(startPage);
              routers[i].children = temp;
              routers[i].children.forEach((item) => {
                Object.defineProperty(item.meta,"parentPath",{
                  value: routers[i].path,
                  enumerable: true,
                  configurable: true,
                  writable:true
                });
              })
          }
          filterAsyncRoutes(routers[i].children).then((res) => {
            routers[i].children = res
          });
        }else{
          let tempname;
          tempname = routers[i].name;
          if(!routers[i].meta.parentPath) {
            let patharr = routers[i].path.split("/");
            routers[i].component = Layout;
            routers[i].path = "/" + patharr[1];
            routers[i].redirect = "/" + patharr[1] + "/" + patharr[2];
            routers[i].children = [
                {
                  path : routers[i].redirect,
                  component : () => import("@/views" + routers[i].redirect + ".vue"),
                  meta: {
                      icon: routers[i].meta.icon,
                      title: routers[i].meta.title,
                      permission: routers[i].meta.permission
                  }
                }
            ]
            delete routers[i].meta
          } else {
            if(!routers[i].component){
                routers[i].component = () => import("@/views" + routers[i].meta.parentPath + "/" + tempname + ".vue");
            }
            routers[i].name = routers[i].meta.parentPath + tempname;
          }

        }
        res.push(routers[i]);
      }
      resolve(res);
     })
}

const state = {
  routes: [],
  addRoutes: [],
  permission: {}
}

const mutations = {
  SET_ROUTE: (state, route) => {
    state.addRoutes = route;
    state.routes = constantRoutes.concat(route)
  },


}

const actions = {
  generateRoutes({ commit }, path) {
    // 产生路由
    return new Promise((resolve,reject) => {
       filterAsyncRoutes(path).then((newlist) => {
          commit("SET_ROUTE",newlist);
          resolve(newlist)
       });

    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/permission.js